<template>
    <a :href="linkValue"
       target="_blank"
       @click="linkClicked()"
       :class="{disabled: linkDisabled}"
       v-show="link.text">
        <i v-show="linkIconClass" :class="linkIconClass"></i>
        {{ link.text }}
    </a>
</template>

<script>
    import axios from "axios";
    import { validEmail, validPhoneNumber, validUrl } from '../helpers/validators';

    export default {
        props: {
            link: {
                type: Object,
                required: true
            },
            preview: {
                type: Boolean
            }
        },
        methods: {
            linkClicked() {
                if(!this.preview) {
                    axios.post('/post/link/click', { link_id: this.link.id, _token: window.csrf_token });
                }
            }
        },
        computed: {
            linkValue() {
                if(!this.link.value) {
                    return '';
                }
                switch(this.link.type) {
                    case 'email':
                        return `mailto:${this.link.value}`;
                    case 'phone_number':
                        return `tel:${this.link.value.replace(/\D/, '')}`;
                    default:
                        if(this.link.value.indexOf('http') !== 0) {
                            return 'http://' + this.link.value;
                        }
                        return this.link.value;
                }
            },
            linkIconClass() {
                if(this.link.type === 'email') {
                    return 'glyphicon glyphicon-envelope';
                }
                if(this.link.type === 'phone number') {
                    return 'glyphicon glyphicon-earphone';
                }
                return '';
            },
            linkDisabled() {
                switch(this.link.type) {
                    case 'email':
                        return !validEmail(this.link.value);
                    case 'phone_number':
                        return !validPhoneNumber(this.link.value);
                    default:
                        return !validUrl(this.link.value);
                }
            }
        }
    }
</script>
